import gql from 'graphql-tag';
import { paginationQuery } from '@/queries/PaginationQuery';

export const publicationSectionQuery = gql`
  query getPublications(
    $author: String,
    $filter: String,
    $limit: Int,
    $paged: Int,
    $subject: String,
    $subType: String,
    $subTypeValue: String,
    $type: String
  ) {
    publications(
      first: $limit
      where: { authorSlug: $author, paged: $paged, subjectSlug: $subject }
    ) {
      nodes {
        excerpt
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        imageSrcset
        publicationData {
          authors {
            author
            type
          }
          fully_illustrated
          hardcover
          height
          num_illustrations
          num_pages
          publication_year
          purchase_url
          softcover
          width
        }
        publicationAuthors(first: 100) {
          nodes {
            name
            publication_authorId
            slug
            sort
          }
        }
        publicationSubjects {
          nodes {
            name
            slug
          }
        }
        slug
        title
      }
    }
    ${paginationQuery}
  }
`;
